import { c as _c } from "react/compiler-runtime";
import { saveLogin, useLoginStatus } from "@website/hooks/auth-manager";
import { useCompatRouter } from "@website/hooks/compat-router";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { isChannel } from "@website/utils/channel/helpers";
import { FORCE_LOGIN_KEY, validQueryStrings } from "@website/widget/login/constants";
import omit from "lodash-es/omit";
export const useLoginModal = () => {
  const $ = _c(19);
  const router = useCompatRouter();
  const queryValue = router?.query?.login_step;
  const isForceLogin = Boolean(router?.query?.[FORCE_LOGIN_KEY]);
  const {
    loginStatus
  } = useLoginStatus();
  let t0;
  if ($[0] !== router) {
    t0 = properties => {
      const {
        isWelcomeScreen,
        isForceLogin: isForceLogin_0
      } = properties || {};
      addEventToTracking(USER_TRACKING_EVENTS.LOGIN_OPENED, {
        product: "core"
      });
      if (isChannel(["b2b", "telesale"])) {
        window.location.href = "/b2b-login";
      } else {
        router?.replace(router?.pathname, {
          ...router?.query,
          ["login_step"]: "phone-number",
          ...(isWelcomeScreen ? {
            isWelcomeScreen: "true"
          } : {}),
          ...(isForceLogin_0 ? {
            [FORCE_LOGIN_KEY]: "true"
          } : {})
        }, {
          shallow: true,
          scroll: false
        });
      }
      return new Promise(_temp);
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onLoginModalOpen = t0;
  let t1;
  if ($[2] !== router) {
    t1 = () => {
      document.dispatchEvent(new CustomEvent("onLoginModalClose", {
        detail: {}
      }));
      return router?.replace(router?.pathname, omit(router?.query, ["login_step", FORCE_LOGIN_KEY]), {
        shallow: true,
        scroll: false
      });
    };
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onLoginModalClose = t1;
  const {
    isLoggedIn
  } = useLoginStatus();
  let t2;
  if ($[4] !== onLoginModalClose) {
    t2 = (accessToken, refreshToken) => {
      document.dispatchEvent(new CustomEvent("onLoginModalEnd", {
        detail: {
          accessToken,
          refreshToken
        }
      }));
      if (accessToken) {
        saveLogin({
          accessToken,
          refreshToken
        });
      }
      onLoginModalClose();
    };
    $[4] = onLoginModalClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onLoginModalEnd = t2;
  let t3;
  if ($[6] !== queryValue) {
    t3 = typeof queryValue === "string" && validQueryStrings.has(queryValue);
    $[6] = queryValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = Boolean(t3);
  let t5;
  if ($[8] !== queryValue) {
    t5 = typeof queryValue === "string" && validQueryStrings.has(queryValue);
    $[8] = queryValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = Boolean(t5);
  const t7 = isForceLogin ? undefined : onLoginModalClose;
  let t8;
  if ($[10] !== isForceLogin || $[11] !== isLoggedIn || $[12] !== loginStatus || $[13] !== onLoginModalEnd || $[14] !== onLoginModalOpen || $[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = {
      loginModalIsOpen: t4,
      onLoginModalOpen,
      onLoginModalEnd,
      open: t6,
      onClose: t7,
      loginStatus,
      isLogin: isLoggedIn,
      isForceLogin
    };
    $[10] = isForceLogin;
    $[11] = isLoggedIn;
    $[12] = loginStatus;
    $[13] = onLoginModalEnd;
    $[14] = onLoginModalOpen;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
function _temp(resolve, reject) {
  document.addEventListener("onLoginModalEnd", resolve);
  document.addEventListener("onLoginModalClose", reject);
}